export default __webpack_public_path__ + "static/media/catalyst.d3ccb424.jpg";